module.exports = __webpack_public_path__ + "static/img/lhb.13cb6b2f.svg";